import type { SxProps, Theme } from '@mui/material';

export const PrimaryIndustrySearchMobileModalStyle: SxProps<Theme> = {
  '& .MuiBackdrop-root': {
    backgroundColor: (theme) => theme.palette.background.default,
  },
};

export const PrimaryIndustrySearchMobileModalWrapperStyle: SxProps<Theme> = {
  px: 3,
  py: 1,
  pb: 0,
};

export const PrimaryIndustrySearchMobileCloseModalButtonStyle: SxProps<Theme> = {
  p: 0.5,
  minWidth: 'auto',
  width: 'auto',
  mb: 1,
  borderRadius: '50%',
};

export const PrimaryIndustrySearchMobileAutoCompleteStyle: SxProps<Theme> = {
  '& .MuiAutocomplete-endAdornment .MuiAutocomplete-popupIndicator': {
    display: 'none',
  },
};

export const PrimaryIndustrySearchMobileAutoCompletePopperStyle: SxProps<Theme> = {
  width: '100% !important',
  transform: 'translate3d(0px, 120px, 0px) !important',

  '.MuiAutocomplete-paper': {
    boxShadow: 'none',

    '& .MuiAutocomplete-listbox': {
      maxHeight: `calc(100dvh - 110px)`,
      p: 0,
    },

    '& .MuiAutocomplete-listbox .MuiAutocomplete-option': {
      p: 2,
      pl: 4,
    },
  },
};
